
<template>
    
        <mars-view :class="['clue-collection-container', pageName]"><c-popup :show="show" class="clue-collection-popup"><mars-view class="main-content-box"><mars-view class="title">{{ pageName === 'qa' ? '0元预约金牌律师1对1咨询' : '一键获取律师1对1咨询' }}</mars-view><mars-view class="close-box" @click.native="closePopupFn"><mars-view class="close"></mars-view></mars-view><mars-view v-if="pageName === 'qa'" class="banner-box"><mars-image class="man-icon" src="https://lvlin-base.cdn.bcebos.com/law/pages/images/cluepop-man.png"></mars-image></mars-view><mars-view v-else-if="lawClueConfigImageUrl" class="banner-box" :style="{backgroundImage: 'url(' + lawClueConfigImageUrl + ')'}"></mars-view><mars-view class="form-wraper"><mars-view v-for="(item, index) in formData" :key="index"><mars-view v-if="item.type === 'phone'" class="form-wraper-item phone" data-selectType="phone" @click.native="handleShowPhonePopup(true)"><mars-view class="form-wraper-item-title">
                            {{ item.title || '' }}
                            <mars-text v-if="item.isRequire" class="title-light">*</mars-text></mars-view><mars-view :class="['form-wraper-item-value', !item.value ? 'no-value' : 'phone-value']"><mars-view>
                                {{ item.value || item.placeholder }}
                            </mars-view><mars-view v-if="item.value" class="clear-box" @click.native.stop="clearPhoneNumber"><mars-view class="clear"></mars-view></mars-view></mars-view></mars-view><mars-view v-if="item.type === 'city'" class="form-wraper-item" @click.native.stop="handleCheck('showCityPopup')"><mars-view class="form-wraper-item-title">
                            {{ item.title }}
                            <mars-text v-if="item.isRequire" class="title-light">*</mars-text></mars-view><mars-view :class="['form-wraper-item-value', !item.value ? 'no-value' : '']"><mars-view>{{ item.value || item.placeholder }}</mars-view><mars-view class="arrow"></mars-view></mars-view></mars-view><mars-view v-if="item.type === 'picker'" class="form-wraper-item" @click.native="handleCheck('applyArea')"><mars-view class="form-wraper-item-title">
                            {{ item.title }}
                            <mars-text v-if="item.isRequire" class="title-light">*</mars-text></mars-view><mars-view :class="['form-wraper-item-value', !item.value ? 'no-value' : '']"><mars-view>{{ item.value || item.placeholder }}</mars-view><mars-view class="arrow"></mars-view></mars-view></mars-view><mars-view v-if="item.type === 'desc'" class="form-wraper-item" @click.native.stop="handleCheck('showQuestionDescPopup')"><mars-view class="form-wraper-item-title desc">
                            {{ item.title }}
                            <mars-text v-if="item.isRequire" class="title-light">*</mars-text></mars-view><mars-view :class="['desc-box', item.value ? '' : 'no-value']">
                            {{ item.value || item.placeholder }}
                        </mars-view></mars-view></mars-view></mars-view><mars-view class="protocol-box"><mars-view class="protocol-commom" @click.native="handleCheck('agreementApply')"><mars-view class="protocol-checkbox" :class="agreementApply ? 'protocol-checkbox-check' : 'protocol-checkbox-uncheck'"></mars-view><mars-view>
                        同意
                        <mars-text class="protocol-desc" @click.native.stop="tapFn('userServeRules')">《咨询服务协议》</mars-text>
                        及<mars-text class="protocol-desc" @click.native.stop="tapFn('userPrivacyRules')">《隐私政策》</mars-text></mars-view></mars-view><mars-view class="protocol-commom" @click.native="handleCheck('tpApply')"><mars-view class="protocol-checkbox" :class="tpApply ? 'protocol-checkbox-check' : 'protocol-checkbox-uncheck'"></mars-view><mars-view>
                        免费获得额外3家
                        <mars-text class="protocol-desc" @click.native.stop="handleCheck('applyPhone')"> 法律服务方 </mars-text> 致电
                    </mars-view></mars-view></mars-view><mars-view class="marquee-box"><top-bubble v-if="dynamics.length > 0" :dynamics="dynamics" :is-center="true"></top-bubble></mars-view><mars-view class="submit-box"><mars-view :class="['submit-btn', (!allowSubmit && pageName !== 'qa') ? 'disabled' : '']" @click.native="submitForm"><div class="submit-title">{{ pageName === 'qa' ? '立即免费获得专业律师回电' : '立即提交，免费获取专业律师回电' }}</div><mars-view v-if="pageName === 'qa'" class="light"></mars-view></mars-view></mars-view></mars-view></c-popup><more-service-institution :is-show="applyPhone" @close="handleCheck('applyPhone')"></more-service-institution><question-desc-popup v-if="showQuestionDescPopup" class="question-desc-popup" :show="showQuestionDescPopup" :ori-content="consultContent" @close="handleCheck('showQuestionDescPopup')" @textInput="textChange" @onConfirm="onConfirm"></question-desc-popup><type-select :is-show="applyArea" :cur-type="consultArea" :has-active-bg="true" @typeChange="clickAreaItem" @close="handleCheck('applyArea')"></type-select><city-select :is-show="showCityPopup" :ori-city-name="oriCityName" :ori-province-name="oriProvinceName" @cityChange="cityChange" @close="handleCheck('showCityPopup')"></city-select><phone-select :is-show="showPhonePopup" @close="handleShowPhonePopup(false)" @phoneChange="phoneChange"></phone-select></mars-view>
    
</template>

<script>
/* globals getApp, Page, swan, getCurrentPages, globalData */
import Popup from "../../components/common/newPopup.vue";
import topBubble from "../../pages/consultform/components/top-bubble.vue";
import { getData, request } from '../../static/utils/request.js';
import questionDescPopup from "./questionDescPopup.vue";
import { nav } from '../../static/utils/navigate';
import { reqPathTo } from '../../static/utils/env.js';
import log from '../../static/utils/ubcLog';
import moreServiceInstitution from "../../components/clue/moreServiceInstitution.vue";
import typeSelect from "../../components/clue/typeSelect.vue";
import phoneSelect from "../../components/clue/phoneSelect.vue";
import citySelect from "../../components/clue/citySelect.vue";
export default {
  components: {
    'c-popup': Popup,
    'top-bubble': topBubble,
    'question-desc-popup': questionDescPopup,
    'more-service-institution': moreServiceInstitution,
    'type-select': typeSelect,
    'phone-select': phoneSelect,
    'city-select': citySelect
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: () => {}
    },
    lawClueConfigImageUrl: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    // 咨询来源点位标识
    from: {
      type: String,
      default: ''
    },
    hasNightClue: {
      type: Boolean,
      default: false
    },
    mapcity: {
      type: String,
      default: ''
    },
    cuid: {
      type: String,
      default: ''
    },
    showtag: {
      type: String,
      default: ''
    },
    pageName: {
      type: String,
      default: ''
    },
    nqid: {
      type: String,
      default: ''
    }
  },
  computed: {
    allowSubmit() {
      let validate = false;
      let formInfo = this.getFormValue(this.formData);
      let {
        user_phone: phone,
        city,
        consult_area: type,
        desc
      } = formInfo || {};
      validate = phone && city && type && (desc && desc.length >= 10 || desc === this.title) && this.agreementApply && this.tpApply;
      return validate;
    }
  },
  watch: {
    show() {
      if (this.show) {
        log.send && log.send({
          serverId: 17260,
          area: 'biaodan-retention',
          action: 'show',
          optype: this.from
        });
      }
    },
    title() {
      this.consultContent = this.title;
      this.formData.map(item => {
        if (item.type === 'desc' && this.title) {
          item.value = this.title;
        }
        return item;
      });
    }
  },
  data() {
    return {
      dynamics: [],
      // 信息配置
      formData: [{
        title: '联系电话',
        isRequire: true,
        type: 'phone',
        keyName: 'user_phone',
        placeholder: '请输入您的手机号',
        value: ''
      }, {
        title: '案件城市',
        isRequire: true,
        type: 'city',
        keyName: 'city',
        placeholder: '请选择案件城市',
        value: ''
      }, {
        title: '咨询类型',
        isRequire: true,
        type: 'picker',
        keyName: 'consult_area',
        placeholder: '请选择咨询类型',
        value: ''
      }, {
        title: '问题描述',
        isRequire: true,
        type: 'desc',
        keyName: 'desc',
        placeholder: '请输入您的问题',
        value: '',
        minLength: 10
      }],
      tpApply: true,
      // 同意免费获额外
      applyPhone: false,
      // 法律服务机构弹窗
      agreementApply: true,
      // 同意隐私
      showPhonePopup: false,
      // 展示手机号弹窗
      showCityPopup: false,
      // 展示选择城市弹窗
      showQuestionDescPopup: false,
      // 展示问题描述弹窗
      phone: null,
      // 手机号
      encrypedPhone: null,
      encrypedCode: null,
      code: null,
      // 验证码
      checkCode: '',
      // 检验之后保存code再次传给后端
      codeTimer: null,
      // 验证码计时器
      codeCountdown: -1,
      // 验证码倒计时
      applyArea: false,
      // 咨询领域弹窗
      consultArea: '',
      // 咨询领域
      // title: '', // 用户的提问query
      adsEid: 0,
      // eid
      cityValue: '',
      provinceValue: '',
      consultContent: '',
      experiment: '',
      oriCityName: '',
      oriProvinceName: ''
    };
  },
  mounted() {
    this.init(this.params || {});
  },
  methods: {
    /**
     * 表单页面初始化
     * @param {params} object 页面url所携带参数
     * @return {void}
     */
    init(params) {
      const location = getApp().globalData.location || {};
      const url = reqPathTo('index', params, '', 'law/formconsult');
      getData({
        url: url,
        data: {
          lat: location.lat || '',
          long: location.long || '',
          mapcity: this.mapcity
        },
        loginNeeded: false,
        needBduss: true
      }).then(data => {
        if (!data) {
          return;
        }
        data.filters && data.filters.forEach(item => {
          item.column = Number(item.column);
        });
        this.encrypedPhone = data.encryped_phone;
        this.cityValue = data.area.city;
        this.oriCityName = data.area.city;
        this.oriProvinceName = data.area.province;
        this.provinceValue = data.area.province;
        // 跑马灯后端返回了100条数据，为优化性能最多轮播10条
        let dynamics = data.guide_msg || [];
        dynamics = dynamics.length > 10 ? dynamics.slice(0, 10) : dynamics;
        this.dynamics = dynamics;
        this.experiment = data.experiment || this.experiment;
        const {
          area = {},
          encryped_phone: encrypedPhone
        } = data || {};
        let {
          city
        } = area;
        this.consultContent = this.title;
        this.formData.map(item => {
          // 手机号
          if (item.type === 'phone' && encrypedPhone) {
            item.value = encrypedPhone;
          }
          // 城市信息
          else if (item.type === 'city' && city) {
            item.value = city;
          }
          // 咨询类型无默认
          // 问题描述
          else if (item.type === 'desc' && this.title) {
            item.value = this.title;
          }
          return item;
        });
      });
    },
    closePopupFn() {
      this.$emit('closeEvent', true);
    },
    /**
     * 点击查看协议跳转
     * @param {type} string 协议类型名称
     * @return {void}
     */
    tapFn(type) {
      nav({
        type: 'nav',
        url: '/pages/static/' + type
      });
    },
    /**
     * 切换弹窗的显示状态
     * @param {checkName} string 弹窗分类名称
     * @return {void}
     */
    handleCheck(checkName) {
      this[checkName] = !this[checkName];
      if (!this[checkName]) {
        return;
      }
      log.send && log.send({
        serverId: 16206,
        area: {
          'showPhonePopup': 'tel',
          'showCityPopup': 'city',
          'applyArea': 'consult',
          'showQuestionDescPopup': 'question'
        }[checkName] || 'popup',
        action: 'click'
      });
    },
    /**
     * 手机号切换
     * @param {*} info
     */

    phoneChange(info) {
      let {
        phone,
        checkCode
      } = info || {};
      this.checkCode = checkCode;
      this.setFormData('phone', phone);
    },
    /**
     * 选择问题领域事件回调
     * @param {area} object 领域内容
     * @return {void}
     */
    clickAreaItem(area) {
      // this.handleCheck('applyArea');
      this.consultArea = area.value;
      this.setFormData('picker', area.value);
    },
    /**
     * 城市选择事件
     * @param {city} city 城市
     */
    cityChange(city) {
      this.handleCheck('showCityPopup');
      this.cityValue = city.cityName;
      this.provinceValue = city.province;
      this.setFormData('city', city.name);
    },
    /**
     * 问题输入框输入文本事件
     * @param {event} object input事件回调参数
     * @return {void}
     */
    textChange(event) {
      this.consultContent = event.detail.value;
      this.setFormData('desc', event.detail.value);
    },
    /**
     * 问题输入框完成事件
     */
    onConfirm() {
      this.handleCheck('showQuestionDescPopup');
    },
    /**
     * 获取表单对应key的value值
     * @param {Array} formData 表单信息
     */

    getFormValue(formData) {
      let objInfo = {};
      formData.forEach(item => {
        objInfo[item.keyName] = item.value;
      });
      return objInfo;
    },
    /**
     * 提交form表单事件
     * @return {void}
     */
    submitForm() {
      let formInfo = this.getFormValue(this.formData);
      let {
        user_phone: phone,
        city,
        consult_area: type,
        desc
      } = formInfo || {};
      let strArr = [];
      let str = '';
      if (!phone) {
        strArr.push('联系电话');
      }
      if (!city) {
        strArr.push('案件城市');
      }
      if (!type) {
        strArr.push('咨询类型');
      }
      if (!desc) {
        strArr.push('问题描述');
      }
      if (strArr.length) {
        str = '请完善您的' + strArr.join('、');
      }
      if (str) {
        this.$api.showToast({
          title: str,
          icon: 'none'
        });
        return;
      }
      if (desc.length < 10 && desc !== this.title) {
        this.$api.showToast({
          title: '问题描述至少填写10个字',
          icon: 'none'
        });
        return;
      }
      if (!this.agreementApply) {
        this.$api.showToast({
          title: '请阅读并同意相关协议',
          icon: 'none'
        });
        return;
      }
      if (!this.tpApply) {
        this.$api.showToast({
          title: '请同意额外服务方致电',
          icon: 'none'
        });
        return;
      }
      this.$api.showLoading({
        title: '表单提交中',
        mask: true
      });
      const params = {
        'consult_content': desc,
        'user_phone': phone,
        city,
        'consult_area': type,
        'approve_cnt': this.tpApply ? 3 : 0,
        'ori_query': this.title || '',
        'use_ori_phone': phone === this.encrypedPhone ? 1 : 0,
        from: this.from,
        code: this.checkCode || '',
        province: this.provinceValue,
        experiment: this.experiment,
        cuid: this.cuid,
        showtag: this.showtag,
        ...(this.nqid && {
          consult_id: this.nqid
        })
      };
      let url = reqPathTo('add_clue', {}, '', 'falv/clue');
      request({
        url: url,
        data: params,
        method: 'post',
        loginNeeded: false,
        needBduss: true,
        header: {
          'content-type': 'application/x-www-form-urlencoded'
        }
      }).then(resp => {
        log.send && log.send({
          serverId: 17260,
          area: 'biaodan-retention',
          action: 'click',
          optype: this.from
        });
        const data = resp && resp.data || {};
        this.$api.hideLoading();
        if (data.data && data.data.is_night_clue) {
          this.closePopupFn();
          this.$emit('openClueFinishModal');
          return;
        }
        if (+data.status === 0) {
          this.$api.showToast({
            title: '联系电话提交成功，请注意来电！',
            icon: 'none'
          });
          this.closePopupFn();
        } else {
          this.$api.showToast({
            title: data.msg || '咨询登记失败～',
            icon: 'none'
          });
        }
      }).catch(err => {
        this.$api.hideLoading();
        this.$api.showToast({
          title: err && err.msg || '咨询登记失败～',
          icon: 'none'
        });
      });
    },
    clearPhoneNumber() {
      this.setFormData('phone', '');
      this.handleShowPhonePopup(true);
    },
    /**
     * 修改手机号码弹框展示控制
     * @param {boolean} isShow  是否展示
     */

    handleShowPhonePopup(isShow) {
      this.showPhonePopup = isShow;
      if (!isShow) {
        this.code = '';
      }
    },
    /**
     * 获取表单中的某一个数据
     * @param {String} type 字段标识（phone、city等）
     */

    getFormData(type) {
      let value = '';
      type && this.formData.forEach(item => {
        if (item.type === type) {
          value = item.value;
        }
      });
      return value;
    },
    /**
     * 给表单中的某一个数据赋值
     * @param {String} type 字段标识（phone、city等）
     * @param {String} value 字段值
     */

    setFormData(type, value) {
      type && this.formData.forEach(item => {
        if (item.type === type) {
          item.value = value;
        }
      });
    }
  }
};
</script>

<style scoped>
.clue-collection-container .apply-popup-intro {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.clue-collection-container .apply-popup-intro .apply-popup-title-right {
  position: relative;
}
.clue-collection-container .apply-popup-intro .apply-popup-title-right .title-close {
  width: 3.14vw;
  height: 3.14vw;
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/clue-collection/clue-collection-popup-close-icon.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.clue-collection-container .apply-popup-intro .apply-popup-title {
  height: 55px;
  line-height: 55px;
  font-family: PingFangSC-Medium;
  font-size: 19px;
  color: #000;
}
.clue-collection-popup .main-content-box {
  position: relative;
  width: 100%;
  padding: 0.17rem 0.17rem 0.39rem 0.17rem;
  background-color: #fff;
  border-radius: 5.07vw 5.07vw 0 0;
  box-sizing: border-box;
}
.clue-collection-popup .main-content-box .title {
  font-family: PingFangSC-Medium;
  font-size: 4.35vw;
  color: #1f1f1f;
  line-height: 4.35vw;
  font-weight: 500;
  text-align: center;
}
.clue-collection-popup .main-content-box .close-box {
  position: absolute;
  z-index: 1;
  width: 7.14vw;
  height: 7.14vw;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 2.83vw;
  right: 2.11vw;
}
.clue-collection-popup .main-content-box .close {
  width: 3.14vw;
  height: 3.14vw;
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/clue-collection/clue-collection-popup-close-icon.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.clue-collection-popup .main-content-box .banner-box {
  width: 100%;
  height: 22.95vw;
  margin-top: 5vw;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.clue-collection-popup .main-content-box .form-wraper {
  background: #fff;
  margin-top: 4.51vw;
}
.clue-collection-popup .main-content-box .form-wraper .form-wraper-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4.11vw;
}
.clue-collection-popup .main-content-box .form-wraper .form-wraper-item.phone {
  margin-top: 0;
}
.clue-collection-popup .main-content-box .form-wraper .form-wraper-item .form-wraper-item-title {
  flex-shrink: 0;
  margin-right: 1.37vw;
  display: flex;
  align-items: center;
  font-family: PingFangSC-Regular;
  font-size: 3.86vw;
  color: #525252;
  line-height: 3.86vw;
  font-weight: 400;
}
.clue-collection-popup .main-content-box .form-wraper .form-wraper-item .form-wraper-item-title .title-light {
  margin-top: 0.84vw;
  margin-left: 0.48vw;
  color: #fd503e;
}
.clue-collection-popup .main-content-box .form-wraper .form-wraper-item .form-wraper-item-value {
  flex: 1;
  height: 9.7vw;
  padding: 0 3.14vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: PingFangSC-Regular;
  font-size: 3.86vw;
  color: #1f1f1f;
  line-height: 3.86vw;
  border: 0.16vw solid #b8b8b8;
  border-radius: 2.17vw;
  box-sizing: border-box;
}
.clue-collection-popup .main-content-box .form-wraper .form-wraper-item .form-wraper-item-value .clear-box {
  height: 9.66vw;
  width: 5.55vw;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.clue-collection-popup .main-content-box .form-wraper .form-wraper-item .form-wraper-item-value .clear-box .clear {
  width: 0.147rem;
  height: 0.147rem;
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/clue-collection/new-icon-clear.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.clue-collection-popup .main-content-box .form-wraper .form-wraper-item .form-wraper-item-value.no-value {
  color: #b8b8b8;
}
.clue-collection-popup .main-content-box .form-wraper .form-wraper-item .desc-box {
  flex: 1;
  height: 15.22vw;
  padding: 2.05vw 3.14vw;
  font-family: PingFangSC-Regular;
  font-size: 3.86vw;
  color: #1f1f1f;
  line-height: 1.43;
  border: 0.16vw solid #b8b8b8;
  border-radius: 2.17vw;
  box-sizing: border-box;
  overflow-y: auto;
}
.clue-collection-popup .main-content-box .form-wraper .form-wraper-item .desc-box.no-value {
  color: #b8b8b8;
}
.clue-collection-popup .main-content-box .protocol-box {
  margin-top: 0.14rem;
  font-family: PingFangSC-Regular;
  font-size: 3.14vw;
  color: #858585;
  line-height: 3.14vw;
  font-weight: 400;
}
.clue-collection-popup .main-content-box .protocol-box .protocol-commom {
  display: flex;
  align-items: center;
  margin-top: 2.42vw;
}
.clue-collection-popup .main-content-box .protocol-box .protocol-commom .protocol-checkbox {
  width: 3.62vw;
  height: 3.62vw;
  margin-right: 1.77vw;
  border-radius: 50%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.clue-collection-popup .main-content-box .protocol-box .protocol-commom .protocol-checkbox-check {
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/clue-collection/choiced-icon.png');
}
.clue-collection-popup .main-content-box .protocol-box .protocol-commom .protocol-checkbox-uncheck {
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/clue-collection/not-choiced-icon.png');
}
.clue-collection-popup .main-content-box .protocol-box .protocol-commom .protocol-desc {
  color: #525252;
}
.clue-collection-popup .main-content-box .marquee-box {
  position: relative;
  height: 24px;
  margin-top: 0.21rem;
}
.clue-collection-popup .main-content-box .submit-box {
  position: relative;
  z-index: 1;
  margin-top: 3.38vw;
}
.clue-collection-popup .main-content-box .submit-box .submit-btn {
  position: relative;
  overflow: hidden;
  height: 11.59vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC-Medium;
  background: #05f;
  color: #fff;
  border-radius: 0.24rem;
}
.clue-collection-popup .main-content-box .submit-box .submit-btn .submit-title {
  text-align: center;
  font-size: 4.35vw;
  line-height: 4.35vw;
}
.clue-collection-popup .main-content-box .submit-box .submit-btn .submit-sub-title {
  text-align: center;
  margin-top: 1.45vw;
  font-size: 2.9vw;
  line-height: 2.9vw;
}
.clue-collection-popup .main-content-box .submit-box .submit-btn .light {
  background-image: url("https://lvlin-base.cdn.bcebos.com/law/pages/images/btn-ani.png");
  background-size: contain;
  position: absolute;
  top: 0;
  left: -14.79vw;
  width: 14.79vw;
  height: 11.59vw;
  -webkit-animation: shadowMove 1s linear;
  animation: shadowMove 1s linear;
  animation-delay: 1s;
}
@keyframes shadowMove {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  100% {
    -webkit-transform: translate3d(100vw, 0, 0);
    transform: translate3d(100vw, 0, 0);
  }
}
.clue-collection-popup .main-content-box .submit-box .submit-btn.disabled {
  background: rgba(0, 85, 255, 0.3);
}
.clue-collection-popup .area-box {
  width: 3.91rem;
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.09rem;
  justify-content: flex-start;
}
.clue-collection-popup .area-box .area-item {
  width: 1.2rem;
  height: 0.47rem;
  background: #f5f6f9;
  border-radius: 0.08rem;
  text-align: center;
  line-height: 0.47rem;
  margin-bottom: 0.1rem;
  font-size: 0.17rem;
  color: #1f1f1f;
  margin-right: 0.1rem;
}
.clue-collection-popup .area-box .area-item-active {
  background: rgba(0, 85, 255, 0.1);
  font-family: PingFangSC-Medium;
  color: #05f;
  font-weight: 500;
}
.clue-collection-container.qa .clue-collection-popup .main-content-box .banner-box {
  height: 18.92vw;
  margin-top: 7vw;
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/images/cluepop-card.png');
  position: relative;
}
.clue-collection-container.qa .clue-collection-popup .main-content-box .banner-box .man-icon {
  width: 27.29vw;
  height: 21.82vw;
  position: absolute;
  right: 1.29vw;
  bottom: 0;
}
.clue-collection-container.qa .clue-collection-popup .main-content-box .form-wraper {
  margin-top: 4.11vw;
}
.clue-collection-container.qa .clue-collection-popup .main-content-box .form-wraper .form-wraper-item .form-wraper-item-value {
  height: 12.08vw;
  border: none;
  background: #f5f6f9;
}
.clue-collection-container.qa .clue-collection-popup .main-content-box .form-wraper .form-wraper-item .form-wraper-item-value .arrow {
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/clue-collection/arrow.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  height: 1.37vw;
  width: 2.58vw;
}
.clue-collection-container.qa .clue-collection-popup .main-content-box .form-wraper .form-wraper-item-title.desc {
  margin-top: -5.78vw;
}
.clue-collection-container.qa .clue-collection-popup .main-content-box .form-wraper .desc-box {
  border: none;
  background: #f5f6f9;
}

</style>
